<template>
    <div class="dltNotce">
        <div class="tit">
            <span v-if="db.length">“体彩超级大乐透”第{{ db[0].cycle }}期</span>
            <span v-if="db.length">{{ db[0].front_week }}开奖</span>
        </div>
        <div class="table" v-if="db.length">
            <div>
                <span>前区号码</span>
                <div>
                    <span>{{ db[0].openNbr.split(' ').slice(0, -2).join(' ') }}</span>
                </div>
            </div>
            <div>
                <span>后区号码</span>
                <div>
                    <span>{{ db[0].openNbr.split(' ').slice(-2).join(' ') }}</span>
                </div>
            </div>
        </div>
        <div class="resolve" v-if="db.length">
            <div class="tit">基本投注开奖结果</div>
            {{ db[0].otherInfo }}
        </div>
        <div class="table2" v-if="list.length">
            <div>
                <span>奖等</span>
                <span>中奖注数</span>
                <span>每注奖额</span>
            </div>
            <div v-for="(item, index) in list" :key="index">
                <span>{{ item.award }}</span>
                <span>{{ item.awardNbr }}</span>
                <span style="
					font-weight: bold;
    				color: red;
				">{{ item.simpleAwardMoney }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            db: [],
            list: [],
        }
    },
    mounted() {
        this.getdb()
    },
    methods: {
        getdb() {
            let lotteryType = 1
            this.$http.get('/stage-api/pre/record/forecast/runBaseLottery?type=' + lotteryType).then(res => {
                // 兼容多种返回结构：res.data 可能是数组，也可能 res 本身就是数组（裸数组/对象透传）
                const base = res && res.data !== undefined ? res.data : res
                const arr = Array.isArray(base) ? base : (Array.isArray(res) ? res : [])
                if (arr[0] && this.$utils) {
                    arr[0].front_week = this.$utils.timestampToWeekday((arr[0].openTimestamp || 0) * 1000)
                    arr[0].front_ymd = this.$utils.timestampToYMD((arr[0].openTimestamp || 0) * 1000)
                }
                this.db = arr
                const cycle = arr[0] ? arr[0].cycle : ''
                this.$http.get('/stage-api/pre/record/forecast/runLottery?type=' + lotteryType + '&cycle=' + cycle).then(res2 => {
                    const inner = res2 && res2.data !== undefined ? res2.data : res2
                    const list = Array.isArray(inner) ? inner : (inner && inner.rows) || []
                    this.list = list.slice(0, 8)
                }).catch(err => {
                    console.error('dlt 奖等列表加载失败', err)
                    this.list = []
                })
            }).catch(err => {
                console.error('dlt 开奖基本信息加载失败', err)
                this.db = []
                this.list = []
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.dltNotce {
    font-weight: bold;
    background-color: #f7fbff;

    >.tit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }

    .table {
        display: flex;
        border: 1px solid rgba(0, 0, 0, 0.2);

        >div {
            display: flex;
            flex-direction: column;

            >span {
                font-weight: bold;
                border-right: 1px solid rgba(0, 0, 0, 0.2);
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                text-align: center;
                background-color: #eeeeee;
                padding: 6px;
            }

            >div {
                span {
                    border-right: 1px solid rgba(0, 0, 0, 0.2);
                }
            }

            &:first-child {
                flex: 5;

                >div {
                    display: flex;
                    color: red;

                    span {
                        flex: 1;
                        text-align: center;
                        padding: 5px;
                    }
                }
            }

            &:last-child {
                flex: 2;

                >div {
                    color: blue;
                    display: flex;

                    span {
                        flex: 1;
                        text-align: center;
                        padding: 5px;
                    }
                }
            }
        }
    }

    .resolve {
        .tit {
            text-align: center;
            padding: 10px 0 0;
        }
    }

    .table2 {
        text-align: center;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-top: 0;
        border-right: 0;
        font-size: 12px;
        margin-top: 5px;

        div {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            border-top: 1px solid rgba(0, 0, 0, 0.2);

            span {
                border-right: 1px solid rgba(0, 0, 0, 0.2);
                padding: 4px;
            }

            &:nth-child(n + 2) {
                font-weight: 400;
            }
        }
    }
}
</style>
